import { z } from "zod";
import { PublicGameConfig } from "./game.js";
export const Role = z.enum(["player", "moderator", "admin", "owner"]);
export const PERMISSIONS = [
    "chat.read",
    "chat.send",
    "chat.rain",
    "chat.moderate",
    "themes.manage",
    "game.manage",
    "audit.read",
    "roles.manage",
];
export const ROLE_PERMISSIONS = {
    player: ["chat.read", "chat.send", "chat.rain"],
    moderator: ["chat.read", "chat.send", "chat.rain", "chat.moderate"],
    admin: [
        "chat.read",
        "chat.send",
        "chat.rain",
        "chat.moderate",
        "themes.manage",
        "game.manage",
        "audit.read",
    ],
    owner: PERMISSIONS,
};
export function hasPermission(role, permission) {
    const parsed = Role.safeParse(role ?? "player");
    return parsed.success && ROLE_PERMISSIONS[parsed.data].includes(permission);
}
export const RoleInput = z.strictObject({ role: Role });
export const GameSettings = PublicGameConfig.pick({
    growthK: true,
    renderMode: true,
    allowPlayerRenderModeChange: true,
    bettingMs: true,
    crashPauseMs: true,
})
    .extend({ allowPlayerRenderModeChange: z.boolean() })
    .partial()
    .strict();
export const PageQuery = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(20),
    cursor: z.string().max(180).optional(),
});
const AuditFilterText = z
    .string()
    .max(128)
    .refine((value) => !value.includes("\0"), {
    message: "Filter must not contain a null character",
});
export const AuditQuery = PageQuery.extend({
    author: AuditFilterText.optional(),
    action: AuditFilterText.optional(),
    from: z.iso.date().optional(),
    to: z.iso.date().optional(),
}).refine((query) => !query.from || !query.to || query.from <= query.to, {
    path: ["to"],
    message: "End date must not precede start date",
});
export const AuditEntry = z.object({
    id: z.string(),
    adminId: z.string(),
    action: z.string(),
    target: z.string(),
    before: z.unknown(),
    after: z.unknown(),
    ip: z.string(),
    createdAt: z.number(),
});
export const AuditPage = z.object({ items: z.array(AuditEntry), nextCursor: z.string().nullable() });
export const AccessResponse = z.object({
    role: Role,
    permissions: z.array(z.enum(PERMISSIONS)),
    guest: z.boolean(),
});
export const GameSettingsResponse = z.object({
    settings: GameSettings,
    effective: z.literal("restart"),
    growthKEffective: z.literal("next-round"),
    timing: PublicGameConfig.pick({
        houseEdge: true,
        edgeMode: true,
        maxMultiplier: true,
        bettingMs: true,
        crashPauseMs: true,
    }),
});
//# sourceMappingURL=admin.js.map